<ng-container *ngIf="(order$ | async) as order">
  <go-back-button></go-back-button>
  <white-card>
    <page-header-actions>
      <page-title [labelKey]="order.name"></page-title>
    </page-header-actions>
    <div class="row-details">
      <div class="column-details">
        <caption-label-box header="TYPE" [label]="'ORDERS.TYPE.' + order.dataType"></caption-label-box>
        <caption-label-box header="STATUS" [label]="('ORDERS.STATUS.' + order.status)"></caption-label-box>
        <div class="box-wrapper">
          <app-caption text="FILTERS"></app-caption>
          <ng-container *ngIf="order.filters.length; else noFilters">
            <div *ngFor="let filter of order.filters" class="label">
              {{ filter.name }}: {{ filter.value }}
            </div>
          </ng-container>
          <ng-template #noFilters>---</ng-template>
        </div>
        <caption-label-box header="ORDERS.PLANNED_DATE" [label]="order.plannedExecutionDate"></caption-label-box>
        <div class="box-wrapper">
          <app-caption text="ORDERS.INSPECTORS"></app-caption>
          <div *ngFor="let user of order.assignedTo" class="label">
            {{ getUser(user) }}
          </div>
        </div>
        <caption-label-box *ngIf="order.towerForm" header="ORDERS.TOWER_FORM" [label]="order.towerForm.name!"></caption-label-box>
        <caption-label-box *ngIf="order.spanForm" header="ORDERS.SPAN_FORM" [label]="order.spanForm.name!"></caption-label-box>
      </div>
      <div class="column-data">
        <ng-container *ngIf="order.towers.length">
          <div class="data-header">{{ 'TOWERS' | translate }}</div>
          <grid-master
              [rowData]="order.towers"
              [columnDefs]="setColumns(order.towers)"
              [sizeColumnsToFit]="false"
              [height]="height"
          >
          </grid-master>
        </ng-container>
        <hr *ngIf="order.towers.length && order.spans.length" class="divider">
        <ng-container *ngIf="order.spans.length">
          <div class="data-header">{{ 'SPANS' | translate }}</div>
          <grid-master
            [rowData]="order.spans"
            [columnDefs]="setColumns(order.spans)"
            [sizeColumnsToFit]="false"
            [height]="height"
          >
          </grid-master>
        </ng-container>
      </div>
    </div>
  </white-card>
</ng-container>
